import { changePagination } from './change-pagination/index.tsx';
import {
	executeSearch,
	refreshSearch,
	updateSearchFilter,
	updateSearchIql,
} from './execute-search/index.tsx';
import { fetchUncappedCount } from './fetch-uncapped-count/index.tsx';
import {
	failUpdateObjectFilterExperience,
	startUpdateObjectFilterExperience,
	triggerSuccessfulObjectFilterExperience,
} from './set-object-filter-experience/index.tsx';
import { setSearchMode } from './set-search-mode/index.tsx';
import { setSelectedColumns } from './set-selected-columns/index.tsx';
import { setSummableColumns } from './set-summable-columns/index.tsx';
import { updateOrderBy } from './update-order-by/index.tsx';

export const actions = {
	executeSearch,
	updateSearchIql,
	updateSearchFilter,
	updateOrderBy,
	refreshSearch,
	setSelectedColumns,
	setSummableColumns,
	setSearchMode,
	changePagination,
	triggerSuccessfulObjectFilterExperience,
	startUpdateObjectFilterExperience,
	failUpdateObjectFilterExperience,
	fetchUncappedCount,
} as const;

export type Actions = typeof actions;
